import React from "react";
import { Card, Text, Group, Badge, Divider, Stack, Box } from "@mantine/core";

interface SummaryCardProps {
  serviceLevel?: string;
  requestedBy: string;
  status: string;
  serviceType: string;
  formData: any; // Adding formData prop for dynamic data
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  serviceLevel,
  requestedBy,
  status,
  serviceType,
  formData,
}) => {
  // Filter out empty values from the formData prop
  const filledData = Object.entries(formData).filter(
    ([_, value]) => value !== ""
  );

  // Helper function to format keys to a more readable format
  const formatKey = (key: string) => {
    return key
      .replace(/([A-Z])/g, " $1") // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
  };

  const generateServiceId = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    let id = "";
    for (let i = 0; i < 10; i++) {
      id +=
        Math.random() < 0.5
          ? letters.charAt(Math.floor(Math.random() * letters.length))
          : numbers.charAt(Math.floor(Math.random() * numbers.length));
    }
    return id;
  };

  const serviceId = generateServiceId();

  // Function to truncate text if it exceeds a certain word limit
  const truncateText = (text: string, limit: number) => {
    const words = text.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "...";
    }
    return text;
  };

  return (
    <Card
    miw={'500px'}
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      sx={{
        overflowY: "auto",
        maxHeight: "600px",
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Text weight={500} size="lg" mb="md">
          Summary
        </Text>
        <Badge color={"red"} variant="filled" ml="xs">
          {status}
        </Badge>
      </Box>

      <Divider my="sm" />

      <Group position="apart" mb="xs">
        <Text weight={500} style={{ flex: 1 }}>
          Service Id:
        </Text>
        <Text style={{ flex: 1, textAlign: "right" }}>{serviceId}</Text>
      </Group>

      {/* <Group position="apart" mb="xs">
        <Text weight={500} style={{ flex: 1 }}>
          Service Level:
        </Text>
        <Text style={{ flex: 1, textAlign: "right" }}>{serviceLevel}</Text>
      </Group> */}

      <Group position="apart" mb="xs">
        <Text weight={500} style={{ flex: 1 }}>
          Requested By:
        </Text>
        <Text style={{ flex: 1, textAlign: "right" }}>
          {"HC logistics"}
        </Text>
      </Group>

      <Group position="apart" mb="xs">
        <Text weight={500} style={{ flex: 1 }}>
          Service Type:
        </Text>
        <Text style={{ flex: 1, textAlign: "right" }}>{serviceType}</Text>
      </Group>

      <Divider my="sm" />

      {/* Dynamic rendering of form data in two-column layout */}
      <Stack spacing="xs">
        {filledData.map(([key, value], index) => (
          <Group
            key={index}
            position="apart"
            mb="xs"
            style={{ alignItems: "center" }}
          >
            <Text weight={500} style={{ flex: 1, marginRight: 10 }}>
              {formatKey(key)}:
            </Text>
            <Text style={{ flex: 1, textAlign: "right" }}>
              {typeof value === "object" && value instanceof Date
                ? value.toLocaleDateString()
                : truncateText(value as string, 10)}{" "}
              {/* Set word limit here */}
            </Text>
          </Group>
        ))}
      </Stack>
    </Card>
  );
};
